<template>
  <Cell :error="error" :error-position="errorPosition" :editable="editable" class="cell-unit">
    <v-menu offset-y transition="slide-y-transition">
      <template v-slot:activator="{ on, attrs }">
        <div
          v-bind="attrs"
          class="dropdown-line"
          :contenteditable="editable"
          v-on="on"
          @input="autocomplete"
          @focus="selectAll"
          @keydown.down.prevent="focusOnMenu"
        >
          {{ val ? unitName(val.name) : '' }}
          <Icon v-if="val" type="chevron-down" size="16" />
        </div>
      </template>
      <div class="dropdown-body unit-dropdown-body">
        <DropdownMenuElement
          v-for="unit in filtered ? filteredUnits : units"
          :key="unit.name"
          @click="() => change(unit)"
          @keydown.enter="() => change(unit)"
          @keydown.down.prevent="focusOnNext"
        >
          {{ unitName(unit.name) }}
        </DropdownMenuElement>
      </div>
    </v-menu>
  </Cell>
</template>

<script>
  import { mapState, mapActions } from 'vuex';
  import Cell from '@/components/common/Cell';
  import unitName from '@/utils/mixins/get-unit-name';
  import Icon from '@/components/ui/Icon';
  import { VMenu } from 'vuetify/lib';
  import DropdownMenuElement from '@/components/ui/dropdown-menu/DropdownMenuElement';

  export default {
    name: 'UnitDropdown',
    components: { Cell, Icon, VMenu, DropdownMenuElement },
    props: {
      val: Object,

      editable: {
        type: Boolean,
        default: false,
      },

      error: {
        type: String,
        default: '',
      },
      errorPosition: {
        type: String,
        default: 'right', // left|right
      },
    },
    mixins: [unitName],
    data() {
      return {
        open: false,
        oneTry: false,
        filtered: false,
        filteredUnits: [],
      };
    },
    computed: mapState({
      unitsOpened: (state) => state.global.unitsOpened,
    }),
    watch: {
      unitsOpened: function () {
        if (this.oneTry) this.oneTry = false;
        else this.open = false;
      },
      open: function (val) {
        if (val) {
          this.changeGlobalUnits();
          this.oneTry = true;
        }
      },
    },
    methods: {
      ...mapActions('global', ['changeGlobalUnits']),
      change(unit) {
        this.$emit('change', unit);
        this.filtered = false;
        this.open = false;
      },
      selectAll(e) {
        this.focus = true;
        let range = document.createRange();
        range.selectNodeContents(e.target.firstChild || e.target);
        let selection = window.getSelection();
        selection.removeAllRanges();
        selection.addRange(range);
      },
      autocomplete(e) {
        if (!this.open) this.open = true;
        let search = e.target.innerText.trim();
        this.filteredUnits = this.units.filter(
          (unit) => unit.name.includes(search) || unit.full_name.includes(search)
        );
        this.filtered = true;
      },
      focusOnMenu() {
        if (!this.open) this.open = true;
        this.$refs.menu.firstChild.focus();
      },
      focusOnNext(e) {
        e.target.nextSibling.focus();
      },
    },
  };
</script>
<style lang="scss" scoped>
  .dropdown-line {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    justify-content: space-between;
  }

  .dropdown-line[aria-expanded='true'] {
    svg {
      transform: rotate(180deg);
    }
  }

  .unit-dropdown-body {
    max-height: 150px;
    width: auto;
  }
</style>
